import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as icons_solid from '@fortawesome/free-solid-svg-icons';

export default React.memo(({ className='', links = [], small }) => {
	const size = small ? 'fs-6' : 'fs-4';
	const li = links.map((e, i) => {
		return (
			<li className={`breadcrumb-item text-dark fs-4 ${i === links.length - 1 ? 'active' : ''}`} key={i}>
				{e.url ? (
					<Link className="text-decoration-none" to={e.url}  style={{ color: '#2E2868' }}>
						{i === 0 && <FontAwesomeIcon className="me-2 fs-5" icon={icons_solid.faArrowLeftLong} />}
						{e.label}
					</Link>
				) : (
					<span className={`${size}`}>{e.label}</span>
				)}
			</li>
		);
	});
	return (
		<div className={`container-fluid px-0 pt-3 ${className}`}>
			<nav aria-label="breadcrumb">
				<ol className="breadcrumb mb-0">
					{li}
				</ol>
			</nav>
		</div>
	);
});
